import { render, staticRenderFns } from "./snackbar.component.vue?vue&type=template&id=e37756be&"
import script from "./snackbar.component.vue?vue&type=script&lang=js&"
export * from "./snackbar.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports